import React from "react";
import {
  Table,
  TableHead,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
} from "@/components/ui/table";
import { TabsContent } from "@/components/ui/tabs";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPayrollListByStaffId } from "@/redux/slice/staff-management/staff-attendance";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";

function Payroll() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const { id } = useParams();
  const { payrollLoading, payrollPagination, staffPayrollList } = useSelector(
    (state) => state.staffManage.attendance
  );

  console.log(staffPayrollList);

  useEffect(() => {
    dispatch(
      fetchPayrollListByStaffId({
        staff_id: id,
        page: page,
      })
    );
  }, [id, dispatch]);

  if (payrollLoading) return <OnlyTableSekeleton header={false} />;
  return (
    <TabsContent value="payroll">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Basic Salary</TableHead>
            <TableHead>Overtime</TableHead>
            <TableHead>Bonus</TableHead>
            <TableHead>Deductions</TableHead>
            <TableHead>Gross Pay</TableHead>
            <TableHead>Net Pay</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {staffPayrollList && staffPayrollList?.length > 0 ? (
            staffPayrollList?.map((item, i) => (
              <TableRow key={i}>
                <TableCell>{item?.payslip_date || "N/A"}</TableCell>
                <TableCell>{item?.basic_salary || "N/A"}</TableCell>
                <TableCell>{item?.overtime || 0}</TableCell>
                <TableCell>{item?.bonus || 0}</TableCell>
                <TableCell>{item?.deductions || 0}</TableCell>
                <TableCell>{item?.gross_pay || "N/A"}</TableCell>
                <TableCell>{item?.net_pay || "N/A"}</TableCell>
                <TableCell
                  className={`${
                    item?.status === "paid" ? "text-cgreen" : "text-cred"
                  }`}
                >
                  {item?.status}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} className="text-center py-4">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TabsContent>
  );
}

export default Payroll;
